import Vue from 'vue'
import Keycloak from 'keycloak-js'

import store from '@/store/index.js'

let Plugin = {}
function validateCompany (url) {
  const dominio = url.split('.')[1]
  const subdominio = url.split('.')[0]
  if (subdominio === 'localhost') {
    return 'bea360'
  } else if (subdominio === 'devdesk') {
    return 'devportal'
  } else {
    if (dominio === 'beaware360') { // prep
      return `${subdominio.slice(0, -4)}portal`
    } else { // prod
      return subdominio
    }
  }
}

async function getParametrosCompany () {
  const company = validateCompany(window.location.hostname)
  await Promise.resolve(store.dispatch('auth/getCompanyForKeycloak', company))
}

await getParametrosCompany()

if (store.state.auth.activeKeycloak === 'SI') {
  const initOptions = {
    url: store.state.auth.urlKeycloak, realm: store.state.auth.realm, clientId: store.state.auth.clientIdKeycloak, onLoad: 'login-required'
  }
  const _keycloak = new Keycloak(initOptions)
  _keycloak.onTokenExpired = function () {
    _keycloak.updateToken().then(() => {
    })
  }

  Plugin = {
    install (Vue) {
      Vue.$keycloak = _keycloak
    }
  }

  Plugin.install = Vue => {
    Vue.$keycloak = _keycloak
    Object.defineProperties(Vue.prototype, {
      $keycloak: {
        get () {
          return _keycloak
        }
      }
    })
  }

  Vue.use(Plugin)
}

export default Plugin
